import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose'
import { FormattedMessage } from 'react-intl'

import withComposedClassName from '../../../../composables/withComposedClassName'
import { IconHeart, IconHeartEmpty } from '../../../shared/Icon'

import Button from '../../../shared/Button'
import styles from './FavoriteButton.module.scss'

const propTypes = {
  iconOnly: PropTypes.bool,
  isFavorite: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

const defaultProps = {
  iconOnly: false,
}

const FullHeart = withComposedClassName(styles.fullHeart)(IconHeart)
const EmptyHeart = withComposedClassName(styles.emptyHeart)(IconHeartEmpty)

const removeMessage = (
  <FormattedMessage
    id='ZipCodeDetail.button.unfavorite'
    defaultMessage='Remove from favorites'
  />
)
const addMessage = (
  <FormattedMessage
    id='ZipCodeDetail.button.favorite'
    defaultMessage='Add to favorites'
  />
)

const FavoriteButton = compose(
  withProps(({ className, iconOnly, isFavorite, zipcode }) => {
    const message = isFavorite ? removeMessage : addMessage

    return {
      'data-qa': 'favoriteButton',
      'aria-label': isFavorite
        ? `remove ${zipcode} from favorites`
        : `add ${zipcode} to favorites`,
      children: iconOnly ? null : message,
      className: classnames(
        iconOnly ? styles.iconOnly : styles.root,
        className
      ),
      iconStart: isFavorite ? FullHeart : EmptyHeart,
      minimal: iconOnly,
    }
  })
)(
  ({
    zipcode, // ignore
    marketInterest, // ignore
    addFavorite, // ignore
    removeFavorite, // ignore
    isFavorite, // ignore
    iconOnly, // ignore
    ...restProps
  }) => <Button {...restProps} />
)

FavoriteButton.propTypes = propTypes
FavoriteButton.defaultProps = defaultProps

export default FavoriteButton
